<template>

  <div class="check" :class="{selected : selected}" v-on:click="updateSelected()">
    <div class="icon">
      <i class="far fa-square" v-if="!selected"></i>
      <i class="fas fa-check-square" v-if="selected"></i>
    </div>
    <span>{{chapter.title}}</span>
    <div class="clearfix"></div>
  </div>
</template>

<script>
  import _ from 'underscore'
  import { mapState, mapGetters, mapActions } from 'vuex'

  export default {
    props: {
      chapter: Object,
    },

    components: {
    },

    created() {
    },

    methods: {
      updateSelected() {
        if (!this.selected) {
          this.$store.dispatch('addChaptersToExport', { chapterIds: [this.chapter.id]})
        } else {
          this.$store.dispatch('removeChaptersFromExport', { chapterIds: [this.chapter.id] })
        }
      }
    },

    data() {
      return {
        
      }
    },

    computed: {
      ...mapGetters({
        selectedExportChapterIds: 'selectedExportChapterIds',
      }),
      selected() {
        return _.contains(this.selectedExportChapterIds, this.chapter.id);
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  input {width:20px;height:20px;float:left;margin-right:20px;}
  label {font-size:16px;float:left;margin-top:2px;}
  .check {color:#AAAAAA;cursor:pointer;font-size:15px;margin-bottom:10px;position:relative;padding-left:30px;}
  .check:hover {color:#666666;}
  .check.selected { color: #4285f4;}
  .check .icon {float:left;font-size:20px;position:absolute;top:0px;left:0px;}
  .check span { float: left; padding-top:2px;margin-left:12px;}
</style>



// WEBPACK FOOTER //
// ChapterRow.vue?382b3708